import { Injectable } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { SigncoFormArray, SigncoFormGroup } from "@ramudden/models/form";

@Injectable({
    providedIn: "root",
})
export class SigncoUntypedFormBuilder extends UntypedFormBuilder {
    override group(controlsConfig: { [key: string]: any }, extra?: any): SigncoFormGroup {
        return new SigncoFormGroup(super.group(controlsConfig, extra).controls);
    }

    override array(controlsConfig: any[], _validatorOrOpts?: any, _asyncValidator?: any): SigncoFormArray {
        return new SigncoFormArray(
            controlsConfig.map((control) => super.control(control)),
            _validatorOrOpts,
            _asyncValidator,
        );
    }
}
